const processCardsArr = Array.from(document.querySelectorAll('.process-card'));

export function setActiveProcessCard(nextCard) {
  if (!nextCard) return;
  processCardsArr.forEach((card) => {
    card.classList.toggle('is-active', card === nextCard);
  });
}

if (processCardsArr.length) {
  const defaultActiveCard =
    processCardsArr.find((card) => card.classList.contains('is-active')) ||
    processCardsArr[0];

  setActiveProcessCard(defaultActiveCard);

  processCardsArr.forEach((card) => {
    card.addEventListener('click', () => {
      if (window.innerWidth <= 640) return;
      if (card.classList.contains('is-active')) return;
      setActiveProcessCard(card);
    });
  });
}
